/*
 * @Author: Dong
 * @Date: 2022-04-20 11:14:22
 * @LastEditors: zhang lin
 * @LastEditTime: 2023-02-03 09:57:33
 */
import {
  SELECT_NODE_VERSION,
  CLEAR_FILE_CONFIG,
  CHAGNE_NODE_FORM,
  SET_HOSTS,
  SET_INSTALLA_TYPE,
  SET_NODE_DATA,
} from '../constant';
import { nodeConfigStatus } from './types';

const defaultStates: nodeConfigStatus = {
  nodeVersions: {}, // 所选的节点
  nodeFormData: {}, // 扩展节点的表单信息
  hosts: {}, // ip数据
  installationType: {}, // 安装类型
  nodeData: [], // 节点源数据
};

const page = (state = { ...defaultStates }, action: any) => {
  const { type, payload } = action;

  switch (type) {
    // 清空数据
    case CLEAR_FILE_CONFIG: {
      return {
        ...defaultStates,
      };
    }

    // 选择版本
    case SELECT_NODE_VERSION: {
      const temp = { ...state.nodeVersions, ...payload };
      const newSelectedVersions: { [x: string]: string } = {};
      Object.keys(temp).forEach((key) => {
        if (!temp[key]) return;
        newSelectedVersions[key] = temp[key];
      });

      return {
        ...state,
        nodeVersions: {
          ...newSelectedVersions,
        },
      };
    }
    // 设置表单数据
    case CHAGNE_NODE_FORM: {
      return {
        ...state,
        nodeFormData: payload,
      };
    }
    // 设置hosts
    case SET_HOSTS: {
      return {
        ...state,
        hosts: payload,
      };
    }
    // 设置hosts
    case SET_INSTALLA_TYPE: {
      return {
        ...state,
        installationType: { ...state.installationType, ...payload },
      };
    }

    // 设置hosts
    case SET_NODE_DATA: {
      return {
        ...state,
        nodeData: payload,
      };
    }

    default:
      return state;
  }
};

export default page;
